export default "__VITE_ASSET__CworaPUl__"